<template>
    <div class="date-times-picker">
    </div>
</template>

<script>
export default {
    name: 'MyDateTimesPicker',
    props: {
    },
    data() {
        return {
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/timeHorizon/index.vue